<template>
  <div class="table-responsive">
    <table
      v-if="Array.isArray(userOrderHistoryData)"
      class="table table-striped"
    >
      <thead>
        <tr>
          <th scope="col">Zamówienie</th>
          <th scope="col">Status zamówienia</th>
          <th scope="col">Status płatności</th>
          <th scope="col">Data zamówienia</th>
          <th scope="col">Termin płatności</th>
          <th scope="col">Kwota</th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="userHistory in userOrderHistoryPaginatedData"
          :key="userHistory.id"
        >
          <td class="align-middle">
            {{ userHistory.fullOrderName }}
          </td>
          <td class="card-text align-middle" v-if="userHistory.status === 0">
            Zamówienie w realizacji
          </td>
          <td class="card-text align-middle" v-if="userHistory.status === 1">
            Zamówienie zrealizowane
          </td>
          <td class="card-text align-middle" v-if="userHistory.status === 2">
            Zamówienie anulowane
          </td>
          <!--                    -->
          <td
            class="card-text align-middle"
            v-if="userHistory.payment_status === 0 && userHistory.status !== 2"
          >
            Nie dotyczy
          </td>
          <td
            class="card-text align-middle"
            v-else-if="
              userHistory.payment_status === 0 && userHistory.status === 2
            "
          >
            ----
          </td>
          <td
            class="card-text align-middle"
            v-if="userHistory.payment_status === 1 && userHistory.status !== 2"
          >
            Oczekiwanie na płatność
          </td>
          <td
            class="card-text align-middle"
            v-else-if="
              userHistory.payment_status === 1 && userHistory.status === 2
            "
          >
            ----
          </td>
          <td
            class="card-text align-middle"
            v-if="userHistory.payment_status === 2 && userHistory.status !== 2"
          >
            Płatność uregulowana
          </td>
          <td
            class="card-text align-middle"
            v-else-if="
              userHistory.payment_status === 2 && userHistory.status === 2
            "
          >
            ----
          </td>
          <td
            class="card-text align-middle"
            v-if="userHistory.payment_status === 3 && userHistory.status !== 2"
          >
            Płatność odrzucona
          </td>
          <td
            class="card-text align-middle"
            v-else-if="
              userHistory.payment_status === 3 && userHistory.status === 2
            "
          >
            ----
          </td>
          <!--                    -->
          <td class="align-middle">
            {{ userHistory.orderdate.substring(0, 10) }}
          </td>
          <td class="align-middle">
            {{ userHistory.paymentdate.substring(0, 10) }}
          </td>
          <td class="align-middle">
            {{ round2dec(userHistory.price) }}&nbsp;{{ userHistory.currency }}
          </td>
          <td class="align-middle">
            <form :action="hostname" method="GET">
              <input
                type="hidden"
                name="action"
                :value="Request.downloadFile"
              />
              <input
                type="hidden"
                name="fv_orderNumber"
                :value="userHistory.orderid"
              />
              <div
                v-if="
                  userHistory.status === 0 && userHistory.payment_status === 1
                "
              >
                <button
                  type="submit"
                  class="btn-standard_payment"
                  formmethod="GET"
                >
                  Pro forma
                </button>
              </div>
              <div v-else></div>
            </form>
          </td>
          <td class="align-middle">
            <div
              v-if="
                userHistory.payment_link !== null &&
                userHistory.status === 0 &&
                (userHistory.payment_status === 1 ||
                  userHistory.payment_status === 3)
              "
              class="col-auto"
            >
              <button
                @click="onPaymentButtonClick(userHistory.payment_link)"
                class="btn-standard_payment"
              >
                Płatność online
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <ul class="pagination">
      <li class="pagination-item">
        <button
          id="paginationNavBtn"
          type="button"
          class="btn-standard"
          @click="onFirstPageClick"
          :disabled="isOnFirstPage"
        >
          Pierwsza
        </button>
      </li>
      <li class="pagination-item">
        <button
          id="paginationNavBtn"
          type="button"
          class="btn-standard"
          @click="onPreviousPageClick"
          :disabled="isOnFirstPage"
        >
          Poprzednia
        </button>
      </li>
      <!-- 1, 2, 3... -->
      <li v-for="page in pages" :key="page.name" class="pagination-item">
        <button
          type="button"
          @click="onPageClick(page.name - 1)"
          :disabled="page.isDisabled"
          class="btn-standard"
          :class="{ active: isPageActive(page.name - 1) }"
        >
          {{ page.name }}
        </button>
      </li>
      <li class="pagination-item">
        <button
          id="paginationNavBtn"
          type="button"
          class="btn-standard"
          @click="onNextPageClick"
          :disabled="isOnLastPage"
        >
          Następna
        </button>
      </li>
      <li class="pagination-item">
        <button
          id="paginationNavBtn"
          type="button"
          class="btn-standard"
          @click="onLastPageClick"
          :disabled="isOnLastPage"
        >
          Ostatnia
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { round2dec } from "@/utils/helpers";
import { Request } from "@/utils/request";

export default {
  name: "Pagination",

  computed: {
    Request() {
      return Request;
    },

    startPage() {
      if (this.userOrderCurrentPage === 0) {
        return 0;
      }

      if (this.userOrderCurrentPage === this.totalPagesAmount - 1) {
        const start = this.totalPagesAmount - this.maxVisibleButtons;

        if (start <= 0) return 0;
        else return start;
      }

      return this.userOrderCurrentPage - 1;
    },

    totalPagesAmount() {
      return Math.ceil(
        this.userOrderHistoryData.length / this.userOrdersPerPage
      );
    },

    pages() {
      const range = [];

      for (
        let i = this.startPage;
        i <
        Math.min(
          this.startPage + this.maxVisibleButtons,
          this.totalPagesAmount
        );
        i++
      ) {
        range.push({
          name: i + 1,
          isDisabled: i === this.userOrderCurrentPage,
        });
      }

      return range;
    },

    isOnFirstPage() {
      return this.userOrderCurrentPage === 0;
    },

    isOnLastPage() {
      return this.userOrderCurrentPage === this.totalPagesAmount - 1;
    },

    userOrderHistoryPaginatedData() {
      const start = this.userOrderCurrentPage * this.userOrdersPerPage;
      const end = start + this.userOrdersPerPage;

      return this.userOrderHistoryData.slice(start, end);
    },
  },

  data() {
    return {
      price: null,
      currency: null,
      paymentdate: null,
      fullOrderName: null,
      orderid: null,

      userOrderCurrentPage: 0,
      userOrdersPerPage: 5,
      maxVisibleButtons: 3,
    };
  },

  mounted() {
    this.userOrderHistoryData = this.userOrderHistoryData.reverse();
  },

  props: {
    userOrderHistoryData: {
      type: Array,
      required: true,
    },
  },

  methods: {
    round2dec,

    onFirstPageClick() {
      return (this.userOrderCurrentPage = 0);
    },

    onPreviousPageClick() {
      return this.userOrderCurrentPage--;
    },

    onPageClick(page) {
      return (this.userOrderCurrentPage = page);
    },

    onNextPageClick() {
      return this.userOrderCurrentPage++;
    },

    onLastPageClick() {
      return (this.userOrderCurrentPage = this.totalPagesAmount - 1);
    },

    isPageActive(page) {
      return this.userOrderCurrentPage === page;
    },

    onPaymentButtonClick(dotPayLink) {
      let link = document.createElement("a");
      link.href = dotPayLink;
      link.target = "_blank";
      link.click();
    },
  },
};
</script>

<style scoped>
.pagination {
  list-style-type: none;
  display:inline-table;
}
.pagination-item {
  display: inline;
}
.active {
  background-color: #50d8af;
  color: #ffffff;
}
#paginationNavBtn:disabled {
  background-color: #6c757d;
  color: white;
}
</style>
